<template>
  <div>
    <v-fade-transition mode="out-in">
      <avalonNewsSingle
          v-if="businessTemplate === 'avalon'"
          key="Avalon"
          :alias="alias"
          :news-alias="newsAlias"/>
    </v-fade-transition>
  </div>
</template>

<script>
import avalonNewsSingle from "@/components/templates/Avalon/UI/avalonNewsSingle";
import {mapState} from "vuex";

export default {
  name: "TemplateLoaderNews",
  props : ['alias','newsAlias'],
  components : {
    avalonNewsSingle
  },
  computed : {
    ...mapState('templates', ['businessTemplate']),
  }
}
</script>

<style scoped>

</style>